import { render, staticRenderFns } from "./tab-contato.vue?vue&type=template&id=40b53054&scoped=true&"
import script from "./tab-contato.vue?vue&type=script&lang=js&"
export * from "./tab-contato.vue?vue&type=script&lang=js&"
import style0 from "./tab-contato.vue?vue&type=style&index=0&id=40b53054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b53054",
  null
  
)

export default component.exports